import React, { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { HiX, HiOutlinePlusCircle, HiOutlineMinusCircle } from 'react-icons/hi'
import Select from "./SelectMenu";
import SortableTable from "./SortableTable";
import BoxPlot from "./BoxPlot";
import ChartComponent from "./Chart";

export default function Statistics({ data = {}, condition, open, onClose }) {
    const [boxPlotData, setBoxPlotData] = useState(null);
    const [statData, setStatData] = useState(null);
    const [statHeader, setStatHeader] = useState(null);
    const [cartoData, setCartoData] = useState(null);
    const [cartoHeader, setCartoHeader] = useState(null);
    const [showElement, setShowElement] = useState(false);
    const [correctData, setCorrectData] = useState(null);
    const [incorrectData, setIncorrectData] = useState(null);

    const toggleElementVisibility = () => {
        setShowElement(!showElement); // Toggle the state to show/hide the table
      };
    
    const properties = [
    { id: 1, code: 'NBLET', name: 'Nombre de lettres' }, 
    { id: 2, code: 'NBSYLL', name: 'Nombre de syllabes à l\'écrit' },
    { id: 3, code: 'NBPHON', name: 'Nombre de phonèmes' },
    { id: 4, code: 'NBGRAPH', name: 'Nombre de graphèmes' },
    { id: 5, code: 'FRFOMA', name: 'Fréquence des formes dans les manuels scolaires' },
    { id: 6, code: 'FRFOLI', name: 'Fréquence des formes dans la littérature' },
    { id: 7, code: 'FRFOFI', name: 'Fréquence des formes dans les sous-titres de films' },
    { id: 8, code: 'FRLELI', name: 'Fréquence des lemmes dans la littérature' },
    { id: 9, code: 'FRLEFI', name: 'Fréquence des lemmes dans les sous-titres de films' },
    { id: 10, code: 'COGPTTY', name: 'Correspondance Phonème/Graphème (CPG)' },
    { id: 11, code: 'COPGTTY', name: 'Correspondance Graphème/Phonème (CGP)' },
    ]

    const handlePropertySelected = (property) => {
    console.log("Selected property code: ", property, " and condition is ", condition);
    if (property && condition === 2) {
      let correct = {}
      let incorrect = {}
      Object.entries(data).forEach(mot => {
        if (typeof mot[1].ORTHO === 'string' && mot[0] !== "top") {
          if (mot[1].FORM === 'taglex') {
            correct[mot[1].ORTHO] = mot[1][property]
          } else if (mot[1].FORM === 'untaginlex' || mot[1].FORM === 'unlexinlex' || mot[1].FORM === 'taglexinlex') {
            incorrect[mot[1].ORTHO] = mot[1][property]
          }
        }
      });
      setCorrectData(correct)
      setIncorrectData(incorrect)
      setBoxPlotData(null)
      setStatData(null)
      setStatHeader(null)
      setCartoData(null)
      setCartoHeader(null)
    } else {
      if (property) {
        // Data for cartography
        const word = [];
        if (condition === 0) {
        Object.entries(data).forEach(mot => {
            if (typeof mot[1].ORTHO === 'string' && mot[0] !== "top" && mot[1].FORM === 'taglex') {
                if (mot[1][property] === null) {
                    mot[1][property] = 0
                }
                word.push({ Index: mot[0], Mot: mot[1].ORTHO, Valeur: mot[1][property] })
            }
        })
        } else if (condition === 1) {
        Object.entries(data).forEach(mot => {
            if (typeof mot[1].ORTHO === 'string' && mot[0] !== "top" &&  (mot[1].FORM === 'untaginlex' || mot[1].FORM === 'taglexinlex' || mot[1].FORM === 'unlexinlex')) {
                if (mot[1][property] === null) {
                    mot[1][property] = 0
                }
                word.push({ Index: mot[0], Mot: mot[1].ORTHO, Valeur: mot[1][property] })
            }
        })
        }

        // const cdata = collector(word)
        const cdata = word
        // console.log("Cartography: ", cdata)
        setCartoData(cdata)
        setCartoHeader(["Index", "Mot", "Valeur"])

        // Data for boxplot
        const bdata = {
        q1: data["25%"][property],
        median: data["50%"][property],
        q3: data["75%"][property],
        mean: data.mean[property],
        min: data.min[property],
        max: data.max[property],
        }
        
        // const vdata = word.map(item => item.Valeur)
        // console.log("Boxplot: ", bdata)
        setBoxPlotData(bdata)

        // Data for stat table
        const sdata = [
        {Statistique: "Nb de Mot (N)", Score: data.count[property]},
        {Statistique: "Moyenne (μ)", Score: data.mean[property]},
        {Statistique: "Écart-type (σ)", Score: data.std[property]},
        {Statistique: "Minimum", Score: data.min[property]},
        {Statistique: "Premier quartile", Score: data["25%"][property]},
        {Statistique: "Médiane", Score: data["50%"][property]},
        {Statistique: "Troisième quartile", Score: data["75%"][property]},
        {Statistique: "Maximum", Score: data.max[property]}
        ];
        // console.log("Statistics: ", sdata)
        setStatData(sdata)
        setStatHeader(["Statistique", "Score"])
      }
      else {
          setBoxPlotData(null)
          setStatData(null)
          setStatHeader(null)
          setCartoData(null)
          setCartoHeader(null)
          setCorrectData(null);
          setIncorrectData(null);
      }
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all w-full my-6 mx-full max-w-4xl">
                
                <div>
                    <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <span className="pt-4 isolate inline-flex rounded-md shadow-sm">
                        <button
                        className="relative -ml-px inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-xl font-medium text-gray-700 hover:bg-gray-100"
                        type="button"
                        onClick={() => {
                            onClose();
                            setBoxPlotData(null);
                            setStatData(null);
                            setStatHeader(null);
                            setCartoData(null);
                            setCartoHeader(null);
                            setCorrectData(null);
                            setIncorrectData(null);
                        }}
                        >
                        <HiX />
                        </button>
                    </span>
                    <span className="pt-4 isolate inline-flex rounded-md shadow-sm">
                        <Select options={properties} onPropertySelected={handlePropertySelected} />
                    </span>
                    </div>
                    <div className="relative p-6 flex-auto max-h-[60vh] overflow-y-auto">
                        {(cartoData && statData && boxPlotData) && (
                        <div>
                        <h1 className="py-4 block text-md font-medium text-gray-700">Boîte à moustaches</h1>
                        <BoxPlot data={boxPlotData} />
                        
                        <h1 className="py-4 block text-md font-medium text-gray-700">Tableau des statistiques</h1>
                        <SortableTable data={statData} headers={statHeader} />
                        <div className="flex items-center justify-between cursor-pointer" onClick={toggleElementVisibility}>
                            <h1 className="py-4 inline-flex block text-md font-medium text-gray-700">Liste des mots</h1>
                            {showElement ? <HiOutlineMinusCircle size="24"/> : <HiOutlinePlusCircle size="24"/>}
                        </div>
                        {showElement &&  <SortableTable data={cartoData} headers={cartoHeader} />}
                        </div>
                        )}
                        {(correctData && incorrectData) && (
                        <div>
                          <ChartComponent correctData={correctData} incorrectData={incorrectData} />
                        </div>
                        )}
                    </div>
                </div>
                
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
